import React, { useMemo } from 'react'

import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useCacheContext } from '@/context/CacheContext'
import { familyStyleToText, getGoogleFontLink } from '@/shared/gapi'

export interface FontSelectProps {
  id?: string
  onChange: (opt: string) => void
  value?: string
}
export function FontSelect({ id, value, onChange }: FontSelectProps) {
  const { isFontLoading, allFonts } = useCacheContext()

  const selected = allFonts.find(({ family }) => family === value)
  return (
    <SelectDropdown
      id={id}
      windowed
      value={selected}
      withSearch
      menuDefaultSize={false}
      menuContainerClassName='min-w-[200px]'
      onChange={(opt) => onChange(opt.family)}
      options={allFonts}
      optionLabel={(opt) => opt.family}
      renderOption={(opt) => {
        return isFontLoading ? (
          <span className='loading spin' />
        ) : (
          <div>
            <link
              href={getGoogleFontLink({
                [`${opt.family}`]: {},
              })}
              rel='stylesheet'
              type='text/css'
            />
            <div style={{ fontFamily: opt.family }}>{opt.family}</div>
          </div>
        )
      }}
      menuAfterClassName='gap-2 border-t bdr'
    />
  )
}

export function FontStyleSelect({
  id,
  value,
  onChange,
  fontFamily,
}: {
  id: string
  value?: string
  onChange: (next: string) => void
  fontFamily?: string
}) {
  const { allFonts } = useCacheContext()
  const selectedFamily = useMemo(() => {
    return allFonts.find(({ family }) => family === fontFamily)
  }, [allFonts, fontFamily])

  const variants = useMemo(() => selectedFamily?.variants || [], [selectedFamily?.variants])

  const selected = useMemo(
    () =>
      variants.find((v) => {
        if (v === value) {
          return true
        } else {
          if (v === '400' || (v === 'regular' && value === '400') || value === 'regular') {
            return true
          }
        }
        return false
      }),
    [variants, value]
  )

  return (
    <SelectDropdown
      id={id}
      menuContainerClassName='min-w-[150px]'
      onChange={onChange}
      value={selected}
      renderOption={(opt) => {
        return familyStyleToText(opt)
      }}
      options={variants}
    />
  )
}
